import React from "react";
import "./GeneralCards.css"; // Import the external CSS

const cardData = [
  {
    id: 1,
    title: "Beautiful Layout",
    description: "Located near Mancherial, ideal for investment.",
    image: "https://fortuneinfradevelopers.com/wp-content/uploads/2020/12/VIEW-01.jpg",
    tag: "For Sale",
  },
  {
    id: 2,
    title: "Premium Plot",
    description: "Gated community with 24/7 security.",
    image: "https://www.agsprotect.com/hubfs/unnamed-1.png",
    tag: "Sold Out",
  },
  {
    id: 3,
    title: "Sandalwood Project",
    description: "Comes with 20 sandalwood trees & maintenance.",
    image: "https://tse3.mm.bing.net/th/id/OIP.0wfRmAyGw5_jNN653_etswAAAA?r=0&rs=1&pid=ImgDetMain&o=7&rm=3",
    tag: "Hot Deal",
  },
  {
    id: 4,
    title: "Luxury Farm Plot",
    description: "Nature-rich plots with premium facilities.",
    image: "https://tse2.mm.bing.net/th/id/OIP.Iep8WRR2L3oQnBsIA4akMQHaE8?r=0&rs=1&pid=ImgDetMain&o=7&rm=3",
    tag: "Limited",
  },
  {
    id: 5,
    title: "Investment Spot",
    description: "Fast-growing area perfect for long-term gains.",
    image: "https://th.bing.com/th/id/R.000c918a9e328cf80b299233e197d06e?rik=I%2fvcDtfRcaUPFA&riu=http%3a%2f%2fwww.stevewilliamskitchens.co.uk%2fwp-content%2fuploads%2f2016%2f06%2fluxurious-interior-design-for-your-new-home-3.jpg&ehk=CKFH%2b1FRTBAJMK4ZyUSxhSi71nCtTGcfwTvaB830MIk%3d&risl=&pid=ImgRaw&r=0",
    tag: "Hot Deal",
  },
  {
    id: 6,
    title: "Affordable Plot",
    description: "Best price for a prime location plot.",
    image: "https://dyimg1.realestateindia.com/prop_images/2139345/1188534_1.jpg",
    tag: "For Sale",
  },
];

const tagColors = {
  "For Sale": "green",
  "Sold Out": "red",
  "Hot Deal": "orange",
  "Limited": "purple",
};

const GeneralCards = () => {
  return (
    <div className="cards-section">
      <h2 className="cards-title">Our Latest Projects</h2>
      <div className="cards-grid">
        {cardData.map(({ id, title, description, image, tag }) => (
          <div className="card" key={id}>
            <img src={image} alt={title} className="card-image" />
            <div className="card-content">
              <div className="card-header">
                <h3 className="card-title">{title}</h3>
                {tag && (
                  <span
                    className="card-tag"
                    style={{ backgroundColor: tagColors[tag] || "blue" }}
                  >
                    {tag}
                  </span>
                )}
              </div>
              <p className="card-description">{description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GeneralCards;
